import * as types from './taxLineItemsTypes';

export function transformResponseToTaxLineItems(response) {
  return response.data.resources.map((data) =>
    types.mkTaxLineItem({
      id: data.id,
      formId: data.formId,

      txfId: data.txfId,

      name: data.name,
      description: data.description,

      displayOrder: data.displayOrder,
    }),
  );
}
